import Loadable from '../../components/loadable';

const SyncWorkOutChangesModal = Loadable({
  loader: () => import('react/pages/workouts/sync_workout_changes_modal'),
  type: 'modal',
});

angular.module('gym').value('SyncWorkOutChangesModal', SyncWorkOutChangesModal);
